import { has } from 'lodash';
import pluralize from 'pluralize';

pluralize.addIrregularRule('was', 'were');

const stakeholderImportReport = (result) => {
    if (has(result, 'stakeholders') && Array.isArray(result.stakeholders) && result.stakeholders.length > 0) {
        const distributionLists = new Map();
        const stakeholdersCreated = result.stakeholders.filter((i) => i.status === 'created');
        const stakeholdersUpdated = result.stakeholders.filter((i) => i.status === 'updated');
        const stakeholdersFailed = result.stakeholders.filter((i) => i.status === 'failed');

        result.stakeholders.forEach((stakeholder) => {
            if (
                has(stakeholder, 'distribution_lists') &&
                Array.isArray(stakeholder.distribution_lists) &&
                stakeholder.distribution_lists.length > 0
            ) {
                stakeholder.distribution_lists.forEach((list) => {
                    let subscribed, failed;
                    const exists = distributionLists.get(list.id);
                    if (exists) {
                        subscribed = list.status === 'success' ? exists.subscribed + 1 : exists.subscribed;
                        failed = list.status === 'failed' ? exists.failed + 1 : exists.failed;
                    } else {
                        subscribed = list.status === 'success' ? 1 : 0;
                        failed = list.status === 'failed' ? 1 : 0;
                    }
                    distributionLists.set(list.id, { name: list.name, subscribed, failed });
                });
            }
        });

        const distributionListsArray = Array.from(distributionLists.values());

        const totalSubscribed = distributionListsArray.map((i) => i.subscribed).reduce((a, b) => a + b, 0);

        const totalSubscribeFailed = distributionListsArray.map((i) => i.failed).reduce((a, b) => a + b, 0);

        return {
            stakeholdersCreated,
            stakeholdersUpdated,
            stakeholdersFailed,
            distributionLists,
            totalSubscribed,
            totalSubscribeFailed,
        };
    }
};

const generateHtmlReportSummary = (report) => {
    let li;
    const ul = document.createElement('ul');

    if (report.stakeholdersCreated.length > 0) {
        li = document.createElement('li');
        li.appendChild(
            document.createTextNode(
                `${report.stakeholdersCreated.length} new ${pluralize(
                    'stakeholder',
                    report.stakeholdersCreated.length
                )} ${pluralize('was', report.stakeholdersCreated.length)} added.`
            )
        );
        li.classList.add('text-success');
        ul.appendChild(li);
    }

    if (report.stakeholdersUpdated.length > 0) {
        li = document.createElement('li');
        li.appendChild(
            document.createTextNode(
                `${report.stakeholdersUpdated.length} existing ${pluralize(
                    'stakeholder',
                    report.stakeholdersUpdated.length
                )} ${pluralize('was', report.stakeholdersCreated.length)} updated.`
            )
        );
        li.classList.add('text-warning');
        ul.appendChild(li);
    }

    if (report.stakeholdersFailed.length > 0) {
        li = document.createElement('li');
        li.appendChild(
            document.createTextNode(
                `${report.stakeholdersFailed.length} ${pluralize(
                    'stakeholder',
                    report.stakeholdersFailed.length
                )} failed to import.`
            )
        );
        li.classList.add('text-danger');
        ul.appendChild(li);
    }

    if (report.distributionLists.size > 0) {
        if (report.totalSubscribed > 0) {
            li = document.createElement('li');
            li.appendChild(
                document.createTextNode(
                    `${pluralize('stakeholder', report.totalSubscribed, true)} subscribed to ${pluralize(
                        'list',
                        report.distributionLists.size,
                        true
                    )}.`
                )
            );
            li.classList.add('text-success');
            ul.appendChild(li);
        }

        if (report.totalSubscribeFailed > 0) {
            li = document.createElement('li');
            li.appendChild(
                document.createTextNode(
                    `${pluralize(
                        'stakeholder',
                        report.totalSubscribeFailed,
                        true
                    )} failed to be subscribed to ${pluralize('list', report.distributionLists.size, true)}.`
                )
            );
            li.classList.add('text-danger');
            ul.appendChild(li);
        }
    }

    return ul;
};

export { stakeholderImportReport, generateHtmlReportSummary };
